// src/i18n/es/groups.ts

const groups = {
  name: 'Grupo |||| Grupos',
  
  fields: {
    id: 'ID',
    name: 'Nombre',
    description: 'Descripción',
    directoryId: 'Organización del registro',
    registry: 'Registro',
    hotels: 'Instalaciones',
    totalDevices: 'Nº de Dispositivos',
    isActive: 'Activo',
    hotelCount: 'Nº de Instalaciones',
  },
  
  actions: {
    create: 'Crear Grupo',
    edit: 'Editar Grupo',
    delete: 'Eliminar Grupo',
    view: 'Ver Grupo',
    list: 'Lista de Grupos',
  },
  
  messages: {
    create_success: 'Grupo creado correctamente',
    create_error: 'Error al crear el grupo',
    update_success: 'Grupo actualizado correctamente',
    update_error: 'Error al actualizar el grupo',
    delete_success: 'Grupo eliminado correctamente',
    delete_error: 'Error al eliminar el grupo',
    delete_confirm: '¿Está seguro de que desea eliminar este grupo?',
    delete_with_hotels: 'No se puede eliminar un grupo con instalaciones asignadas',
    no_groups: 'No hay grupos disponibles',
    loading: 'Cargando grupos...',
  },
  
  validation: {
    name_required: 'El nombre del grupo es obligatorio',
    name_min_length: 'El nombre del grupo debe tener al menos 3 caracteres',
    name_max_length: 'El nombre del grupo no puede exceder 100 caracteres',
    description_max_length: 'La descripción no puede exceder 500 caracteres',
    id_required: 'El ID del grupo es obligatorio',
    id_exists: 'Ya existe un grupo con este ID',
  },
  
  list: {
    title: 'Grupos',
    empty: 'No se encontraron grupos',
    search: 'Buscar grupos...',
  },
  
  show: {
    title: 'Detalles del Grupo',
    hotels_section: 'Instalaciones en este Grupo',
    statistics: 'Estadísticas',
    no_hotels: 'No hay instalaciones asignadas a este grupo',
    metadata: 'Metadatos',
  },
  
  create: {
    title: 'Crear Nuevo Grupo',
    subtitle: 'Agregar un nuevo grupo de instalaciones al sistema',
  },
  
  edit: {
    title: 'Editar Grupo',
    subtitle: 'Modificar información del grupo',
  },
};

export default groups;